import { Attributes, DateUtils, Misc, Validation, ValueObject } from '@singularsystems/neo-core';

export default class IDTRatePagedLookupCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = new Date(DateUtils.today().getFullYear(), 0, 1);

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.today();

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "IDT Rate Paged Lookup Criteria";
    }
}